import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi, ScheduleDetailsParams } from 'src/utils';

import { invalidateCalendarSidebarData } from './useDeleteScheduleItemOverrides';

export const useDeleteScheduleItem = () => {
  return useMutation({
    mutationFn: deleteScheduleItem,
    onSuccess: (_, variables) => {
      const {
        currentSidebarDetailsDataParams,
        currentPosition,
        locationGroupId,
      } = variables;

      invalidateCalendarSidebarData(
        currentSidebarDetailsDataParams,
        currentPosition,
        locationGroupId,
      );
      queryClient.refetchQueries(queryKeys.scheduleOverview.invalidateAll());
      queryClient.refetchQueries(queryKeys.schedules.invalidateAll());
    },
  });
};

const deleteScheduleItem = async (payload: {
  scheduleItemId: number;
  currentSidebarDetailsDataParams: ScheduleDetailsParams;
  currentPosition: number;
  narrative?: string;
  locationGroupId: string | undefined;
}) => {
  const { scheduleItemId, currentSidebarDetailsDataParams, narrative } =
    payload;
  const params = new URLSearchParams({
    schedule_id: currentSidebarDetailsDataParams.scheduleId as string,
    schedule_item_id: String(scheduleItemId),
    ...(narrative
      ? {
          narrative,
        }
      : {}),
  });
  const url = `/schedules?${params}`;
  const response = await requestCCApi({
    url,
    method: 'DELETE',
  });

  return response;
};
